import React from "react";

const NISTIA = () => {
  return (
    <div className="bg-black text-white font-secondary">
      {/* Hero Image Section */}
      <section
        className="relative w-full h-[60vh] bg-cover bg-center flex items-center justify-center text-center md:h-[32vh] sm:h-[22vh]"
        style={{ backgroundImage: `url('/nistia1.png')` }}
      ></section>

      {/* Title, Description, and Button Section */}
      <section className="flex flex-col items-center justify-center bg-black py-8 pb-6">
        <h1 className="font-primary text-[3.2rem] mb-4 text-white text-center md:text-[2.2rem] sm:text-[1.5rem]">
          Neuro-optic Integrated Smart Tactic Intelligent&nbsp;Assistant
        </h1>
        <p className="text-[1.2rem] mb-8 text-white text-center max-w-[700px] sm:text-[0.95rem]">
          Smart glasses are wearable devices equipped with advanced technologies
          that have the potential to revolutionize the lives of visually
          impaired individuals.
        </p>
      </section>

      {/* Main Content Section */}
      <section className="py-12">
        <div className="max-w-[900px] mx-auto px-8 flex flex-col items-center">
          <img
            src="/nistia2.png"
            alt="NISTIA Smart Glasses"
            className="block w-full max-w-[1200px] h-auto my-8 rounded-xl shadow-lg md:max-w-[95vw] sm:max-w-[90vw]"
          />
          <p className="text-center text-[1.15rem] mt-6 mb-2 max-w-[900px] w-full md:text-[1rem] md:max-w-[98vw]">
            Specifically designed for blind students, these smart glasses
            integrate various features to enhance their educational experience
            and assist them in their day-to-day activities.
          </p>
        </div>
      </section>
    </div>
  );
};

export default NISTIA;
